import { FC } from "react";
import { Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { Banner } from "../../../../interfaces/Banner";
import FloatingButton from "../FloatingButton";

const MeetouppeopleAreaBanner: FC<Banner> = ({ banners }) => {
  return (
    <section className="banner meetourpeople">
      <Container>
        <div className="caption">
          <h1>
            <FormattedMessage id="page.meetourpeople.banner.title" />
          </h1>
          <p>
            <FormattedMessage id="page.meetourpeople.banner.description" />
          </p>
        </div>
      </Container>
      <FloatingButton />
    </section>
  );
};

export default MeetouppeopleAreaBanner;
